module.exports = __webpack_public_path__ + "img/icon-compare.4ae0ed11.png";